"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Events = exports.EventTypes = void 0;

var _utilities = require("../../utilities");

var _Snippets = _interopRequireDefault(require("./Snippets"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var EventTypes;
exports.EventTypes = EventTypes;

(function (EventTypes) {
  EventTypes["Website"] = "lce_website_events";
})(EventTypes || (exports.EventTypes = EventTypes = {}));

var Events;
exports.Events = Events;

(function (Events) {
  Events["AddPayment"] = "Add Payment";
  Events["CreateAccount"] = "Create Account";
  Events["DeleteAccount"] = "Delete Account";
  Events["EditAccount"] = "Edit Account";
  Events["InSignedMode"] = "InSignedMode";
  Events["GuestInfo"] = "Guest Info";
  Events["Login"] = "Login";
  Events["Transaction"] = "Transaction";
  Events["PageViews"] = "pageviews";
})(Events || (exports.Events = Events = {}));

var TreasureData = {
  treasureData: function treasureData(args) {
    var snippets = _Snippets["default"].tags(args);

    var script = function script() {
      var element = document.createElement('script');
      element.innerHTML = snippets.script;
      return element;
    };

    return {
      script: script
    };
  },
  initialize: function initialize(host, writeKey, database, cookieSyncKey) {
    var treasureData = this.treasureData({
      host: host,
      writeKey: writeKey,
      database: database,
      cookieSyncKey: cookieSyncKey
    });
    var script = treasureData.script();
    !(0, _utilities.doesScriptExist)(script) && document.head.insertBefore(script, document.head.childNodes[0]);
  },
  set: function set(table, data) {
    var _a, _b;

    typeof ((_a = window === null || window === void 0 ? void 0 : window.td) === null || _a === void 0 ? void 0 : _a.set) !== 'undefined' && ((_b = window === null || window === void 0 ? void 0 : window.td) === null || _b === void 0 ? void 0 : _b.set) && window.td.set(table, data);
  },
  fetchGlobalID: function fetchGlobalID(any) {
    var _a, _b;

    typeof ((_a = window === null || window === void 0 ? void 0 : window.td) === null || _a === void 0 ? void 0 : _a.fetchGlobalID) !== 'undefined' && ((_b = window === null || window === void 0 ? void 0 : window.td) === null || _b === void 0 ? void 0 : _b.fetchGlobalID) && window.td.fetchGlobalID(any);
  },
  trackPageview: function trackPageview(table, GoogleSyncCallback) {
    var _a, _b;

    typeof ((_a = window === null || window === void 0 ? void 0 : window.td) === null || _a === void 0 ? void 0 : _a.trackPageview) !== 'undefined' && ((_b = window === null || window === void 0 ? void 0 : window.td) === null || _b === void 0 ? void 0 : _b.trackPageview) && window.td.trackPageview(table, GoogleSyncCallback);
  },
  trackEvent: function trackEvent(table, data) {
    var _a, _b;

    typeof ((_a = window === null || window === void 0 ? void 0 : window.td) === null || _a === void 0 ? void 0 : _a.trackEvent) !== 'undefined' && ((_b = window === null || window === void 0 ? void 0 : window.td) === null || _b === void 0 ? void 0 : _b.trackEvent) && window.td.trackEvent(table, data);
  },
  inSignedMode: function inSignedMode() {
    var _a;

    if (typeof window !== 'undefined' && !!((_a = window === null || window === void 0 ? void 0 : window.td) === null || _a === void 0 ? void 0 : _a.inSignedMode)) {
      return window.td.inSignedMode();
    }

    return false;
  },
  setAnonymousMode: function setAnonymousMode() {
    var _a, _b;

    typeof ((_a = window === null || window === void 0 ? void 0 : window.td) === null || _a === void 0 ? void 0 : _a.setAnonymousMode) !== 'undefined' && !!((_b = window === null || window === void 0 ? void 0 : window.td) === null || _b === void 0 ? void 0 : _b.setAnonymousMode) && window.td.setAnonymousMode();
  }
};
var _default = TreasureData;
exports["default"] = _default;